const MODAL_HTML = `
  <div
    id="form-error-modal-overlay"
    role="dialog"
    aria-modal="true"
    aria-labelledby="form-error-modal-title"
    aria-describedby="form-error-modal-message"
    class="hidden fixed inset-0 z-50 flex items-center justify-center p-4"
  >
    <div
      id="form-error-modal-backdrop"
      class="absolute inset-0"
      style="background-color: rgba(0, 0, 0, 0.55);"
    ></div>

    <div
      id="form-error-modal-container"
      tabindex="-1"
      class="relative bg-white dark:bg-slate-800 rounded-2xl shadow-2xl max-w-md w-full mx-auto p-6 focus:outline-none"
    >
      <button
        type="button"
        id="form-error-modal-close-x"
        aria-label="Cerrar"
        data-testid="form-error-modal-close-x"
        class="absolute top-3 right-3 p-1.5 text-slate-400 hover:text-slate-600 dark:text-slate-500 dark:hover:text-slate-300 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors"
      >
        <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>

      <div class="flex flex-col items-center text-center mb-4">
        <div class="w-14 h-14 bg-red-100 dark:bg-red-900/30 rounded-full flex items-center justify-center mb-3">
          <svg class="h-8 w-8 text-red-500 dark:text-red-400" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>
          </svg>
        </div>
        <h2
          id="form-error-modal-title"
          class="text-xl font-bold text-slate-900 dark:text-slate-100"
        >
          Error
        </h2>
      </div>

      <p
        id="form-error-modal-message"
        class="text-sm text-slate-600 dark:text-slate-400 text-center mb-2"
      ></p>

      <p class="text-xs text-slate-400 dark:text-slate-500 text-center mb-6">
        Puede intentar de nuevo o contactarnos si el problema persiste.
      </p>

      <div class="flex gap-3 justify-center">
        <button
          type="button"
          id="form-error-modal-close-btn"
          data-testid="form-error-modal-close-btn"
          class="px-5 py-2.5 text-sm font-medium text-slate-700 dark:text-slate-300 bg-white dark:bg-slate-700 border border-slate-300 dark:border-slate-600 rounded-lg hover:bg-slate-50 dark:hover:bg-slate-600 transition-colors focus:outline-none focus:ring-2 focus:ring-slate-400"
        >
          Cerrar
        </button>
        <button
          type="button"
          id="form-error-modal-accept-btn"
          data-testid="form-error-modal-accept-btn"
          class="px-5 py-2.5 text-sm font-medium rounded-lg transition-colors focus:outline-none"
          style="background-color: #3b82f6; color: #ffffff; border: none;"
        >
          Aceptar
        </button>
      </div>
    </div>
  </div>
`;

let activeEscHandler = null;

function hideModal() {
  const overlay = document.getElementById('form-error-modal-overlay');
  if (overlay) {
    overlay.classList.add('hidden');
  }
  document.removeEventListener('keydown', activeEscHandler);
  activeEscHandler = null;
}

function showFormErrorModal(message) {
  const messageEl = document.getElementById('form-error-modal-message');
  const overlay = document.getElementById('form-error-modal-overlay');
  const container = document.getElementById('form-error-modal-container');

  if (!overlay || !messageEl || !container) return;

  messageEl.textContent = message;
  overlay.classList.remove('hidden');
  container.focus();

  activeEscHandler = function onEscKey(event) {
    if (event.key === 'Escape') hideModal();
  };
  document.addEventListener('keydown', activeEscHandler);
}

export function initFormErrorModal() {
  if (document.getElementById('form-error-modal-overlay')) return;

  document.body.insertAdjacentHTML('beforeend', MODAL_HTML);

  document
    .getElementById('form-error-modal-close-x')
    .addEventListener('click', hideModal);
  document
    .getElementById('form-error-modal-close-btn')
    .addEventListener('click', hideModal);
  document
    .getElementById('form-error-modal-accept-btn')
    .addEventListener('click', function handleAccept() {
      hideModal();
      if (typeof window.portalFormActions?.resetForm === 'function') {
        window.portalFormActions.resetForm();
      }
    });
  document
    .getElementById('form-error-modal-backdrop')
    .addEventListener('click', hideModal);

  window.showFormErrorModal = showFormErrorModal;
}
